<template>
  <div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      masterDatas: [],
    }),
    computed: {
      ...mapGetters([
        'getRole',
        'getMasterDataName'
      ])
    },
    mounted() {
      if (this.getRole.isDriver) {
        this.$router.replace('DownloadApp');
      } else if (this.getRole.isDispatcher) {
        this.$router.replace('Schedules');
      } else if (this.getRole.isAcn) {
        this.$router.replace('CallLog');
      } else {
        this.$router.replace('Users');
      }
    },
  };

</script>
